import EventBus, { AppEvents } from '../core/EventBus.js';
import { Toast } from '../components/Toast.js';

function showError(message) {
  try { Toast.show(message, 'error'); } catch { console.error(message); }
}

window.addEventListener('error', (e) => {
  const msg = e?.error?.message || e?.message || 'Unexpected error';
  showError('Error: ' + msg);
  EventBus.emit?.(AppEvents.APP_ERROR || 'APP_ERROR', { message: msg, stack: e?.error?.stack });
});

window.addEventListener('unhandledrejection', (e) => {
  const reason = e?.reason;
  const msg = typeof reason === 'string' ? reason : (reason?.message || 'Unhandled promise rejection');
  showError('Error: ' + msg);
  EventBus.emit?.(AppEvents.APP_ERROR || 'APP_ERROR', { message: msg, stack: reason?.stack });
});

